import { render, staticRenderFns } from "./CabinetTransferSummons.vue?vue&type=template&id=3a32dc1b&scoped=true&"
import script from "./CabinetTransferSummons.vue?vue&type=script&lang=js&"
export * from "./CabinetTransferSummons.vue?vue&type=script&lang=js&"
import style0 from "./CabinetTransferSummons.vue?vue&type=style&index=0&id=3a32dc1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a32dc1b",
  null
  
)

export default component.exports